<template>
  <a-row type="flex">
    <a-col :span="3"></a-col>
    <a-col :span="4" class="contact_page_title">联系我们</a-col>
    <a-col :span="17"></a-col>
  </a-row>
  <a-row>
    <a-col :span="3"></a-col>
    <a-col :span="7">
      <div class="contact_page_text">
        <br/>
        <p style="color: black; font-size: 26px; margin-bottom: 1vh;font-weight: bold">联系我们</p>
        <p>我们寻找的人，感念际遇，不生苦毒，尊重对手，战胜自己。</p>
        <p>我们首先成为这样的人，我们就将找到这样的人。</p>
        <p>如您想成为同行者，请联系我们</p>
        <p style="margin-top: 20px;font-size: 16px">上海地址</p>
        <p>上海市黄浦区湖滨路222号企业天地1705-11室</p>
        <p>邮编200021</p>
        <p>电话 （+86）21-61222888</p>
        <p style="margin-top: 20px;font-size: 16px">北京地址</p>
        <p>北京市朝阳区建国门外大街乙12号双子座大厦东塔1908室</p>
        <p>邮编100022</p>
        <p>电话（+86）10-65665096</p>
        <br/>
      </div>
    </a-col>
    <a-col :span="11"><img src="../../../assets/image/map.png" style="width: 45.8vw"></a-col>
  </a-row>


</template>
<script>

export default {
  name: 'Contact_page',
  components: {},
}
</script>
<style scoped>
.contact_page_title {
  background: #2f54eb;
  color: white;
  font-size: 18px;
  text-align: left;
  line-height: 40px;
  padding-left: 2vh;
  text-indent: 2em;
}

.contact_page_text p {
  color: grey;
  margin-bottom: 0;
  font-size: 14px;
}

.contact_page_text {
  text-align: left;
  padding-left: 1vw;
  padding-top: 2vh;
}
</style>
